import { render, staticRenderFns } from "./ModalPatientTasksList.vue?vue&type=template&id=09a3680e&scoped=true&lang=pug"
import script from "./ModalPatientTasksList.vue?vue&type=script&lang=js"
export * from "./ModalPatientTasksList.vue?vue&type=script&lang=js"
import style0 from "./ModalPatientTasksList.vue?vue&type=style&index=0&id=09a3680e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a3680e",
  null
  
)

export default component.exports